import axios from 'axios'

export const postDocumentsUpload = ( document, type, progress ) => {
    let form = new FormData()
    form.append('file', document)
    return axios.post(`${window.URL_API_USER}user/document/upload/${type}`, form, {
        onUploadProgress: progressEvent => {
            let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
            progress(percentCompleted)
        }
    })
}

export const postProfileType = (profileType) =>
    axios.post(`${window.URL_API_USER}user/document/save-profile`, { profileType } )

export const postDocumentsInfo = () =>
    axios.post(`${window.URL_API_USER}user/document/info`)


// WEBPACK FOOTER //
// ./src/App/utils/documents.js